var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated)?_c('a',{staticClass:"linkServices",attrs:{"href":_vm.navLinks.logout}},[_c('div',{staticClass:"frame"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Logout")])]):(!_vm.isAuthenticated)?_c('a',{staticClass:"linkServices",attrs:{"href":_vm.navLinks.login}},[_c('span',{staticClass:"text"},[_vm._v("Login")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1571d99e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginButton.vue
// module id = null
// module chunks = 